/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListResultDto_IdentityRoleDto } from '../models/ListResultDto_IdentityRoleDto';
import type { PagedResultDto_IdentityRoleDto } from '../models/PagedResultDto_IdentityRoleDto';
import type { Volo_Abp_Identity_IdentityRoleCreateDto } from '../models/Volo_Abp_Identity_IdentityRoleCreateDto';
import type { Volo_Abp_Identity_IdentityRoleDto } from '../models/Volo_Abp_Identity_IdentityRoleDto';
import type { Volo_Abp_Identity_IdentityRoleUpdateDto } from '../models/Volo_Abp_Identity_IdentityRoleUpdateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RoleService {

    /**
     * @returns ListResultDto_IdentityRoleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiIdentityRolesAll(): CancelablePromise<ListResultDto_IdentityRoleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/identity/roles/all',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @param extraProperties 
     * @returns PagedResultDto_IdentityRoleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiIdentityRoles(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
extraProperties?: Record<string, any>,
): CancelablePromise<PagedResultDto_IdentityRoleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/identity/roles',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'ExtraProperties': extraProperties,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Volo_Abp_Identity_IdentityRoleDto OK
     * @throws ApiError
     */
    public static postApiAwardApiIdentityRoles(
requestBody?: Volo_Abp_Identity_IdentityRoleCreateDto,
): CancelablePromise<Volo_Abp_Identity_IdentityRoleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/identity/roles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Volo_Abp_Identity_IdentityRoleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiIdentityRoles1(
id: string,
): CancelablePromise<Volo_Abp_Identity_IdentityRoleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/identity/roles/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Volo_Abp_Identity_IdentityRoleDto OK
     * @throws ApiError
     */
    public static putApiAwardApiIdentityRoles(
id: string,
requestBody?: Volo_Abp_Identity_IdentityRoleUpdateDto,
): CancelablePromise<Volo_Abp_Identity_IdentityRoleDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/identity/roles/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAwardApiIdentityRoles(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/identity/roles/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
